/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostPromptSnippetPathParams = NonNullable<operations['postPromptSnippet']['parameters']['path']>;

export type PostPromptSnippetRequestBody = OperationRequestBodyContent<operations['postPromptSnippet']>;

export interface Input extends PostPromptSnippetPathParams {
  apiVersion?: string;
  body: PostPromptSnippetRequestBody;
}

export async function postPromptSnippet(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/ai-configs/prompt-snippets', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
